import 'isomorphic-fetch';
import { Aurelia, PLATFORM } from 'aurelia-framework';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';
import { setupCommunicationToParent, MessagingProxy } from './app/services/cap-proxy';
import { CustomerInfoStore } from './app/services/customer-info-store';
import { OrganizationInfo } from './app/services/organization-info';

declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build

export function configure(aurelia: Aurelia) {
    aurelia.use
        .standardConfiguration()
        .plugin(PLATFORM.moduleName('aurelia-dialog'))
        .plugin(PLATFORM.moduleName('aurelia-validation'));

    interface Remote {
        helloCRM: string;
        getOrganizationData: string;
    }

    class Local {
        constructor() {
        }
        helloCap(first: string, second: string) {
            return `howdy ${first} ${second}`;
        }
    }

    var proxy = setupCommunicationToParent()
        .handleIncomingMessagesUsing(Local)
        .setupRemote<Remote>()
        .start();

    aurelia.container.registerInstance(MessagingProxy, proxy);
    aurelia.container.registerSingleton(OrganizationInfo);
    aurelia.container.registerSingleton(CustomerInfoStore);

    if (IS_DEV_BUILD) {
        aurelia.use.developmentLogging();
    }

    aurelia.start().then(() => aurelia.setRoot(PLATFORM.moduleName('app/components/app/app')));
}



// WEBPACK FOOTER //
// ./ClientApp/boot.ts